import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'pp-vx/dist/components/tile/tile.css';
import React from 'react';
import clsx from 'clsx';

var tileClass = 'ppvx_tile';

var Tile = function (_ref) {
  var _clsx;

  var card = _ref.card,
      children = _ref.children,
      className = _ref.className,
      divider = _ref.divider,
      rest = _objectWithoutProperties(_ref, ["card", "children", "className", "divider"]);

  var tileClasses = clsx(tileClass, (_clsx = {}, _defineProperty(_clsx, "".concat(tileClass, "--divider"), divider), _defineProperty(_clsx, "".concat(tileClass, "--card"), card), _clsx), className);
  return React.createElement("div", _extends({
    className: tileClasses
  }, rest), children);
};

var Header = function (_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["className", "children"]);

  var headerClasses = clsx('ppvx_tile__header', className);
  return React.createElement("div", _extends({
    className: headerClasses
  }, rest), React.createElement("h3", {
    className: "ppvx_tile__header-title"
  }, children));
};

var Content = function (_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["className", "children"]);

  var contentClasses = clsx('ppvx_tile__content', className);
  return React.createElement("div", _extends({
    className: contentClasses
  }, rest), children);
};

var Footer = function (_ref4) {
  var className = _ref4.className,
      children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["className", "children"]);

  var footerClasses = clsx('ppvx_tile__footer', className);
  return React.createElement("footer", _extends({
    className: footerClasses
  }, rest), children);
};

Tile.Header = Header;
Tile.Content = Content;
Tile.Footer = Footer;

export { Tile };
